import Vue from 'vue';
import Component from 'vue-class-component';

import SiteConfigQuery from 'assets/graphql/queries/SiteConfig.graphql';

import currency from 'common/filters/currency';
import getLastTld from 'common/services/utils/getLastTld';
import useKustomerBotHelpers from 'common/composables/kustomerBotHelpers';
import useIsMobile from 'common/composables/useIsMobile.js';
import { useAccountStore } from 'stores/account';
import PromoGrid from 'components/Modals/PromoGrid/PromoGrid.vue';
import promotionalItemsService from 'services/getPromotionalItems.service';

const COLAPINTO_IDS = [
  '525831',
  '525952',
  '526678',
  '526679',
  '526680',
  '526681',
  '526682',
  '526683',
  '526684',
  '526685',
];

Vue.filter('currency', currency);

@Component({
  components: {
    PromoGrid,
  },
  apollo: {
    siteConfig: {
      query: SiteConfigQuery,
    },
  },
  props: {
    surveyQuantity: {
      type: Number,
    },
    rating: {
      type: Number,
    },
    price: {
      type: [String, Number],
      required: true,
    },
    priceInUsd: {
      type: [String, Number],
      default: -1,
    },
    originalPrice: {
      type: [String, Number],
    },
    discount: {
      type: [String, Number],
    },
    isCartFull: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    showError: {
      type: Boolean,
      required: true,
    },
    buttonTouched: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Comprar esta Bigbox',
    },
    buttonStyle: {
      type: String,
      required: false,
      default: 'primary',
    },
    isBoxFriendDay: {
      type: Boolean,
      required: false,
      default: false,
    },
    showMonthly: {
      type: Boolean,
      required: false,
      default: true,
    },
    isReservationBuy: {
      type: Boolean,
      required: false,
      default: false,
    },
    isConsultation: {
      type: Boolean,
      required: false,
      default: false,
    },
    activityId: {
      type: String,
      required: false,
    },
    isPlusActivity: {
      type: Boolean,
      required: false,
      default: false,
    },
    currencySymbol: {
      type: String,
      required: false,
      default: null,
    },
    priceFrom: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayPromotion: {
      type: Boolean,
      default: true,
    },
    isRetailMode: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { isMobile } = useIsMobile();
    const { getPromotionalItems } = promotionalItemsService;
    const { moveUpwardsKustomer, removeUpwardsSlideKustomer } =
      useKustomerBotHelpers();

    return {
      moveUpwardsKustomer,
      removeUpwardsSlideKustomer,
      isMobile,
      getPromotionalItems,
    };
  },
})
export default class PurchaseDetailButtonComponent extends Vue {
  termsFriendDay = false;
  country = getLastTld();
  kustomerWidget = null;
  colapintoIds = COLAPINTO_IDS;
  promotionItems = null;

  async mounted() {
    this.moveUpwardsKustomer();
    this.promotionItems = await this.getPromotionalItems();
  }

  beforeDestroy() {
    this.removeUpwardsSlideKustomer();
  }

  get buttonLabel() {
    //TODO: DELETE THIS MAGIC STRING IN SOME TIME
    if (
      this.isConsultation ||
      COLAPINTO_IDS.includes(this.activityId?.toString())
    ) {
      return 'Consultanos';
    } else {
      const mobileLabel = this.isReservationBuy ? this.buttonText : 'Comprar';
      return !this.isMobile ? this.buttonText : mobileLabel;
    }
  }

  get isUserPlus() {
    const accountStore = useAccountStore();
    return accountStore.getUserIsBigboxPlus;
  }

  get showPrice() {
    if (!this.isPlusActivity) return true;
    return this.isUserPlus;
  }

  get consultationActivityPrice() {
    const price = this.currencySymbol
      ? `${this.currencySymbol} ${this.price}`
      : currency(this.price);
    return this.priceFrom ? `Desde ${price}` : price;
  }

  get showPromotionGrid() {
    return (
      this.$screen.width > 768 &&
      this.promotionItems?.length &&
      this.displayPromotion
    );
  }

  openModal() {
    this.$refs.promoActivityGrid.handleOpenModal();
  }
}
